import React from 'react'

export default function SignOut() {
    return <main>
        <p>SignOut</p>
    </main>
}
